/**
 * External dependencies
 */
import React from "react";
import { Box } from "@towersystems/towersystems-design-system";
import { get } from "lodash";

/**
 * Internal dependencies
 */
import useReportBuilder from "modules/report-builder/use-report-builder";
import FormInputCheckbox from "components/forms/form-checkbox";

const ConfigureStacked = () => {
  const { report, editReport } = useReportBuilder();

  const handleChange = (e) => {
    editReport({ config: { stacked: !get(report, "config.stacked") } });
  };

  return (
    <Box>
      <FormInputCheckbox
        onChange={handleChange}
        label="Stacked"
        checked={!!get(report, "config.stacked")}
      />
    </Box>
  );
};

export default ConfigureStacked;
